const cb1VariantConfig = {
	brandLight: {
		background: { default: 'var(--color-brand-light)', smallSize: 'var(--color-brand-light)' },
		baseText: { headings: 'var(--color-global-black)', paragraphs: 'var(--color-greys-grey9)' },
		addBrandText: {
			default: 'var(--color-brand-mid)',
			smallSize: 'var(--color-global-black)',
		},
		border: 'transparent',
	},

	brandLightWithBorder: {
		background: { default: 'var(--color-brand-light)', smallSize: 'var(--color-brand-light)' },
		baseText: { headings: 'var(--color-global-black)', paragraphs: 'var(--color-greys-grey9)' },
		addBrandText: {
			default: 'var(--color-brand-mid)',
			smallSize: 'var(--color-global-black)',
		},
		border: 'var(--color-brand-mid)',
	},

	whiteWithBorder: {
		background: { default: 'var(--color-global-white)', smallSize: 'var(--color-global-white)' },
		baseText: { headings: 'var(--color-global-black)', paragraphs: 'var(--color-greys-grey9)' },
		addBrandText: {
			default: 'var(--color-brand-mid)',
			smallSize: 'var(--color-brand-mid)',
		},
		border: 'var(--color-brand-mid)',
	},

	grey: {
		background: { default: 'var(--color-greys-grey2)', smallSize: 'var(--color-greys-grey1)' },
		baseText: { headings: 'var(--color-global-black)', paragraphs: 'var(--color-greys-grey9)' },
		addBrandText: {
			default: 'var(--color-brand-mid)',
			smallSize: 'var(--color-brand-mid)',
		},
		border: 'transparent',
	},

	brand: {
		background: { default: 'var(--color-brand-mid)', smallSize: 'var(--color-brand-mid)' },
		baseText: { headings: 'var(--color-global-white)', paragraphs: 'var(--color-global-white)' },
		addBrandText: {
			default: 'var(--color-global-white)',
			smallSize: 'var(--color-global-white)',
		},
		border: 'transparent',
	},

	black: {
		background: { default: 'var(--color-global-black)', smallSize: 'var(--color-global-black)' },
		baseText: { headings: 'var(--color-global-white)', paragraphs: 'var(--color-global-white)' },
		addBrandText: {
			default: 'var(--color-brand-onBlack)',
			smallSize: 'var(--color-global-white)',
		},
		border: 'transparent',
	},
};

export default cb1VariantConfig;
